import { DialogTitle } from "@headlessui/react";
import clsx from "clsx";

/** Props Interface */
interface ModalHeaderProps {
	title: string;
}

export function ModalHeader({ title }: ModalHeaderProps) {
	return (
		<div className={clsx("py-4 border-color border-b w-full text-color modal-padding")}>
			<DialogTitle className="font-semibold text-lg">{title}</DialogTitle>
		</div>
	);
}
